export default __webpack_public_path__ + "static/media/mrs.3c9793d2.png";